export default __webpack_public_path__ + "static/media/Hero's Hauberk.6b16487a.jpg";